import { lazy, Suspense } from "react";
import { PageSkeleton } from "../../customs/skeleton/main";

const Main = lazy(() => import("../../components/Events/licenseRenewalExams/main"));

const LicenseRenewalExams = () => {
  return (
        <Suspense fallback={<PageSkeleton />}>
          <Main />
        </Suspense>
  );
};

export default LicenseRenewalExams;

